import { defineStore } from 'pinia';
import { usePermissionsStore } from '@/stores/permissions.store.js';
import { API } from '@/services';
import { GET_CURRENT_USER_QUERY, GET_CURRENT_USER_PREFERENCES_QUERY, GET_CURRENT_USER_PERMISSIONS_QUERY } from '@/services/user/queries/index.js';
import Cookie from 'js-cookie';
import { useAccountStore } from '@/stores/account.store.js';

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    currentUser: Cookie.get('_pup_user') ? JSON.parse(Cookie.get('_pup_user')) : null,
    currentPermissions: null,
    isPermissionsLoading: false,
    preferences: null,
    errors: null
  }),
  getters: {
    userPreferences() {
      return this.currentUserPreferences;
    },
    emailRegex() {
      return /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;
    },
    passwordRegex() {
      //this version allows any special character
      return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,}$/;
      //original regex which only allowed a subset of special characters
      //return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^_\-\+\(\)\#\=])[A-Za-z\d@$!%*?&^_\-\+\(\)\#\=]{8,}$/;
    }
  },
  actions: {
    updateCurrentUser(user) {
      this.currentUser = user;
      Cookie.set('_pup_user', JSON.stringify(user), {
        expires: 7,
        sameSite: 'strict',
        secure: true
      });
    },

    // async getCurrentUser() {
    //   try {
    //     const res = await API.sendQuery('/graphql/user', GET_CURRENT_USER_QUERY);
    //     if (res.data.data.currentUser) {
    //       this.updateCurrentUser(res.data.data.currentUser);
    //     }
    //
    //     if (res.data.data.userPreferences) {
    //       this.preferences = res.data.data.userPreferences;
    //       console.log('accounts loaded?', useAccountStore().accounts);
    //       // set Active account in account store
    //       const activeAccount = res.data.data.userPreferences.find((pref) => pref.key === 'active_account');
    //       if (activeAccount) {
    //         console.log('Setting active account:', activeAccount);
    //         useAccountStore().activeAccount = JSON.parse(activeAccount.value);
    //       }
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    async getCurrentUserPermissions(payload) {
      try {
        this.isPermissionsLoading = true;
        const res = await API.sendQuery('/graphql/user', GET_CURRENT_USER_PERMISSIONS_QUERY, payload);
        if (res.data.data.currentPermissions) {
          usePermissionsStore().setPermissions(res.data.data.currentPermissions);
        }
        return res.data.data.currentPermissions;
      } catch (error) {
        console.log(error);
      } finally {
        this.isPermissionsLoading = false;
      }
    }

    // async getCurrentUserExternalAuthConnections() {
    //   try {
    //     const res = await API.userSDK.getCurrentUserExternalAuthConnections();
    //     if (res.data.data.externalAuth) {
    //       this.externalAuthConnections = res.data.data.externalAuth;
    //     }
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },

    // async getCurrentUserPreferences() {
    //   try {
    //     const res = await API.sendQuery('/graphql/user', GET_CURRENT_USER_PREFERENCES_QUERY);
    //
    //     if (res.data.data.userPreferences) {
    //       this.preferences = res.data.data.userPreferences;
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }

    // async getCurrentUserSocialChannels(page, limit) {
    //   try {
    //     const res = await API.userSDK.getCurrentUserSocialChannels(page, limit);
    //     if (res.data.data.currentUserSocialChannels) {
    //       this.socialChannels = res.data.data.currentUserSocialChannels.data;
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    // async connectUserWithOAuth(channelType) {
    //   try {
    //     this.isOAuthLoading = true;
    //     this.selectedOAuthProvider = channelType;
    //     const res = await API.userSDK.connectWithOAuth(channelType);
    //     if (res.data.data.externalAuthUrl) {
    //       window.location.replace(res.data.data.externalAuthUrl.url);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //     this.isOAuthLoading = false;
    //   }
    // },

    // async connectUserWithOAuthCallBack(code, service) {
    //   try {
    //     const res = await API.userSDK.connectWithOAuthCallBack(code, service);
    //     if (res.data.data.externalAuthCallback) {
    //       console.log(res.data.data.externalAuthCallback);
    //       await router.replace('/account/password');
    //     }
    //   } catch (error) {
    //     console.log(error);
    //     this.isOAuthLoading = false;
    //   } finally {
    //     this.isOAuthLoading = false;
    //   }
    // }

    // async addCustomSocialChannel(fieldType, channelType, url) {
    //   try {
    //     this.creatorChannelUpdate.fieldType = fieldType;
    //     this.creatorChannelUpdate.isLoading = true;

    //     const res = await API.userSDK.addCustomSocialChannel(channelType, url);

    //     if (res.data.data?.socialChannelAddCustom) {
    //       this.currentUserSocialChannels.push(res.data.data.socialChannelAddCustom);
    //     } else {
    //       // this.errors = res.data.data.socialChannelAddCustom.errors
    //       this.creatorChannelUpdate.fieldType = null;
    //       this.creatorChannelUpdate.isLoading = false;
    //     }
    //     console.log(res);
    //   } catch (e) {
    //     console.log(e);
    //     this.creatorChannelUpdate.fieldType = null;
    //     this.creatorChannelUpdate.isLoading = false;
    //   } finally {
    //     this.creatorChannelUpdate.fieldType = null;
    //     this.creatorChannelUpdate.isLoading = false;
    //   }
    // },

    // async removeCustomSocialChannel(fieldType, channelType) {},

    // async connectUserChannelWithOAuth(fieldType, channelType) {
    //   try {
    //     this.creatorChannelUpdate.fieldType = fieldType;
    //     this.creatorChannelUpdate.isLoading = true;
    //     const res = await API.userSDK.connectUserChannelWithOAuth(channelType);
    //     if (res.data.data.socialChannelConnect) {
    //       window.location.replace(res.data.data.socialChannelConnect.url);
    //     }
    //   } catch (e) {
    //     console.log(e);
    //     this.creatorChannelUpdate.fieldType = null;
    //     this.creatorChannelUpdate.isLoading = false;
    //   } finally {
    //     this.creatorChannelUpdate.fieldType = null;
    //     this.creatorChannelUpdate.isLoading = false;
    //   }
    // },

    // async connectUserChannelWithOAuthPopup(fieldType, channelType) {
    //   try {
    //     this.creatorChannelUpdate.fieldType = fieldType;
    //     this.creatorChannelUpdate.isLoading = true;
    //     const res = await API.userSDK.connectUserChannelWithOAuth(channelType);

    //     if (res.data.data.socialChannelConnect) {
    //       const url = res.data.data.socialChannelConnect.url;
    //       let oauthPopUpWindow = null;
    //       const left = (screen.width - 800) / 2;
    //       const top = (screen.height - 600) / 4;

    //       const strWindowFeatures = `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=600, height=801, top=${top}, left=${left}`;
    //       if (oauthPopUpWindow === null || oauthPopUpWindow.closed) {
    //         oauthPopUpWindow = window.open(url, channelType, strWindowFeatures);
    //       } else if (previousUrl !== url) {
    //         oauthPopUpWindow = window.open(url, channelType, strWindowFeatures);
    //         oauthPopUpWindow.focus();
    //       } else {
    //         oauthPopUpWindow.focus();
    //       }
    //     }

    //     console.log(res);
    //   } catch (e) {
    //     console.log(e);
    //     window.close();
    //     this.creatorChannelUpdate.fieldType = null;
    //     this.creatorChannelUpdate.isLoading = false;
    //   } finally {
    //     this.creatorChannelUpdate.fieldType = null;
    //     this.creatorChannelUpdate.isLoading = false;
    //   }
    // },

    // async connectUserChannelOAuthCallBack(fieldType, channelType, code, service) {
    //   try {
    //     this.isOAuthLoading = true;
    //     const res = await API.userSDK.connectUserChannelWithOAuthCallBack(code, service);
    //     if (res.data.data.socialChannelCallback) {
    //       window.close();
    //       console.log('YES');
    //     }
    //   } catch (e) {
    //     console.log(e);
    //     this.isOAuthLoading = false;
    //   } finally {
    //     this.isOAuthLoading = false;
    //     this.creatorChannelUpdate.fieldType = null;
    //     this.creatorChannelUpdate.isLoading = false;
    //   }
    // }
  }
});
